import { type ReactNode } from 'react'
import { cn } from '#app/shared/lib/misc.js'

export const MainContainer = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <section className={cn(`mx-auto w-full max-w-[1328px]`, className)}>
      {children}
    </section>
  )
}
